

export default {
    bind(el, binding, vnode, oldVnode){
        // console.log(el, binding, vnode, oldVnode);
        el.getElementsByClassName('el-table__body-wrapper')[0].addEventListener('scroll', function scrollHandle(e){
            if(e.target.scrollHeight - e.target.clientHeight - e.target.scrollTop <= 50){
                binding.value()
            }
        })
    },
    inserted(el, binding, vnode, oldVnode){
        
    },
    update(el, binding, vnode, oldVnode){
        
    },
    componentUpdated(el, binding, vnode, oldVnode){
        
    },
    unbind(el, binding, vnode, oldVnode){
        
    }
}


// WEBPACK FOOTER //
// ./src/directives/tableReachBottomScroll/index.js